import { Button, Stack } from '@mui/material';
import React from 'react';
import { getContactCaptureLiveTestUrl } from '../../helpers';
import { useBuilder } from './ContactCaptureBuilderContext';

export const ContactCaptureActionBar = () => {
  const {
    busy,
    controller,
    formInvalid,
    id,
    publish,
    publishing,
    saveDraft,
    saving,
    setDeleteDialogOpen,
  } = useBuilder();
  const record = controller.record;

  return (
    <Stack direction="row" spacing={2} justifyContent={id ? 'space-between' : 'flex-end'} sx={{ pt: 0.5 }}>
      {id && (
        <Button
          color="error"
          variant="contained"
          disabled={busy}
          onClick={() => setDeleteDialogOpen(true)}
        >
          Delete contact capture
        </Button>
      )}
      <Stack direction="row" spacing={1}>
        {record?.publicId && record.status !== 'draft' && (
          <Button
            variant="outlined"
            href={getContactCaptureLiveTestUrl(record)}
            target="_blank"
            rel="noopener noreferrer"
            disabled={busy || record.status !== 'active'}
          >
            Test published widget
          </Button>
        )}
        <Button variant="outlined" disabled={busy || formInvalid} onClick={() => void saveDraft()}>
          {saving ? 'Saving…' : 'Save draft'}
        </Button>
        <Button variant="contained" disabled={busy || formInvalid} onClick={() => void publish()}>
          {publishing ? 'Publishing…' : 'Publish'}
        </Button>
      </Stack>
    </Stack>
  );
};
